export const JOBS_URL = 'https://jobs.7shifts.com/5cb59b84-a071-4f5b-a79d-ce591fef571b';
export const ORDER_ONLINE_URL = 'https://order.toasttab.com/online/theburgerbarn';
